module.exports = __webpack_public_path__ + "static/media/review-one_60x60.ad3668b4.jpg";